import { render, staticRenderFns } from "./DiagnosticRulesForOttawa.vue?vue&type=template&id=c16d0bbe&scoped=true"
import script from "./DiagnosticRulesForOttawa.vue?vue&type=script&lang=js"
export * from "./DiagnosticRulesForOttawa.vue?vue&type=script&lang=js"
import style0 from "./DiagnosticRulesForOttawa.vue?vue&type=style&index=0&id=c16d0bbe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c16d0bbe",
  null
  
)

export default component.exports